import { render } from "./ThePurchase.vue?vue&type=template&id=0a70b7bc&scoped=true&lang=true"
import script from "./ThePurchase.vue?vue&type=script&lang=js"
export * from "./ThePurchase.vue?vue&type=script&lang=js"

import "./ThePurchase.vue?vue&type=style&index=0&id=0a70b7bc&lang=scss&scoped=true"

import exportComponent from "/home/ajdin/forspace-web/forspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a70b7bc"]])

export default __exports__